import React, { Component } from "react";
import { Line, Doughnut } from "react-chartjs-2";

export default class SpecficCourseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passedData: [75, 25],
      lineChart: {
        labels: ["Today", "Yesterday", "Week", "Month", "Year", "Period"],
        datasets: [
          {
            label: "Passed Course",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgba(75,192,192,1)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [65, 59, 80, 81, 106, 95],
          },
        ],
      },
      barChart: {
        labels: ["Passed", "Failed"],
        datasets: [
          {
            label: "My Daily Logins",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgba(75,192,192,1)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [50, 50],
          },
        ],
      },
    };
  }
  componentDidMount() {
    //api will be called here
    // Passed and Failed api will be placed here

    this.setState({
      barChart: {
        datasets: [
          {
            label: "My Daily Logins",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgba(75,192,192,1)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [75, 25],
          },
        ],
      },
    });
  }
  render() {
    return (
      <div>
        <div class="card text-center">
          <div class="card-header">
            <ul class="nav nav-pills card-header-pills">
              <li class="nav-item">
                <a class="nav-link active" href="#/admin/reports/course/1">
                  Overview{" "}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/admin/reports/course/1">
                  Link
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/admin/reports/course/1">
                  User
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/admin/reports/course/1">
                  Tests
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/admin/reports/course/1">
                  Surveys
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/admin/reports/course/1">
                  Assignment
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/admin/reports/course/1">
                  Timeline
                </a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <h5 class="card-title">
              Content and TalentLMS<sub>(SAMP2)</sub>
            </h5>
            <a href="#admin/reports/course" class="btn btn-primary">
              Download Excel
            </a>
          </div>
        </div>
        <div class="row m-2">
          <div class="col-sm-1" />
          <div class="col-sm-2">
            <div class="card">
              <div class="card-body text-light bg-dark text-center">
                <h5 class="card-title">Assigned Learner</h5>
                <p class="card-text">{"This is a Test"}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="card">
              <div class="card-body text-light bg-dark text-center">
                <h5 class="card-title">Compeleted Learner</h5>
                <p class="card-text">{"This is a Test"}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="card">
              <div class="card-body text-light bg-dark text-center">
                <h5 class="card-title">Learner in progress</h5>
                <p class="card-text">{"This is a Test"}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="card">
              <div class="card-body text-light bg-dark text-center">
                <h5 class="card-title">Total Average Course</h5>
                <p class="card-text">{"This is a Test"}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="card">
              <div class="card-body text-light bg-dark text-center">
                <h5 class="card-title">Total Training time</h5>
                <p class="card-text">{"This is a Test"}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-1" />
        </div>
        <div className="row ml-3">
          <div className="col-6 border-right">
            <div className="row">
              <div className="col-6">
                <div className="btn-group">
                  <div className="btn btn-light active">Today</div>
                  <div className="btn btn-light">Yesterday</div>
                  <div className="btn btn-light">Week</div>
                  <div className="btn btn-light">Month</div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <div className="btn-group">
                  <div className="btn btn-light active">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <div className="btn btn-light">
                    <i class="fas fa-list-ul"></i>
                  </div>
                </div>
              </div>
              <Line data={this.state.lineChart}></Line>
            </div>
          </div>
          <div className="col-6 border-right">
            <div className="row">
              <div className="col-6">
                <div className="btn-group">
                  <div className="btn btn-light active">Today</div>
                  <div className="btn btn-light">Yesterday</div>
                  <div className="btn btn-light">Week</div>
                  <div className="btn btn-light">Month</div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <div className="btn-group">
                  <div className="btn btn-light active">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <div className="btn btn-light">
                    <i class="fas fa-list-ul"></i>
                  </div>
                </div>
              </div>
              <Doughnut data={this.state.barChart}></Doughnut>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
